import { Grid, Box, Typography, Stack } from '@mui/material'
import { Modal } from 'Components/Modal'
import { ChildInfoCard } from 'Components/ChildDetails/ChildInfoCard'
import CareNetworkDetails from 'Components/CareNetwork/CareNetworkDetails'
import CaregiverDetails from 'Components/CareNetwork/CaregiverDetails'
import { type ReminderItem } from 'Components/User/ReminderList'
import { type User } from 'core/types'
import { FormatDateValue } from 'core/Utilities'
import { sendPost } from 'hooks/use-fetch'
import S3Avatar from 'Components/S3Image/S3Avatar'

interface ReminderDetailsEditProps {
  onClose: (updated: boolean) => void
  user: User
  data: ReminderItem
}

export function ReminderDetails (props: ReminderDetailsEditProps): JSX.Element {
  function userFacility (): string {
    // get the current facility of the user
    if (props.user.currentISDID != null && props.user.isDs.length !== 0) {
      return props.user.isDs.find(i => i.id === props.user.currentISDID)?.name ?? ''
    } else if (props.user.selectedServiceProviderID != null && props.user.serviceProviders.length !== 0) {
      return props.user.serviceProviders.find(s => s.id === props.user.selectedServiceProviderID)?.name ?? ''
    } else {
      return ''
    }
  }

  const content =
    <Grid container columns={12} spacing={1} >
      <Grid item xs={6} sm={6}>
        <CaregiverDetails childId={props.data.childID} caregiverId={props.data.caregiverID ?? 0} hideEditButton={true} cardCaption='Caregiver to Contact' />
      </Grid>
      <Grid item xs={6} sm={6}>
        <Box className='CardDisplay' data-testid="ChildInfoCard">
          <Stack direction='row' spacing={1}>
            <S3Avatar imageKey={props.user.imageKey ?? ''} alt={`${props.user.firstName} ${props.user.lastName}`} height='50px' width='50px' />
            <Typography variant='body1' sx={{ fontWeight: 'bold', alignContent: 'center' }}>
              {props.user.firstName} {props.user.lastName}
            </Typography>
          </Stack>
          <Box>{userFacility()}</Box>
          <Box>{FormatDateValue(props.data.reminderDate)}</Box>
          <Box>{props.data.reminderNote}</Box>
        </Box>
      </Grid>
      <Grid item xs={6} sm={6}>
        <ChildInfoCard id={props.data.childID} showViewDetailsLink={true} />
      </Grid>
      <Grid item xs={6} sm={6}>
        <CareNetworkDetails childId={props.data.childID} readOnly={true} redirectText='' />
      </Grid>
    </Grid >

  const onComplete = async (): Promise<void> => {
    await sendPost(`/Communication/MarkReminderComplete?reminderID=${props.data.reminderID}`, {})
    props.onClose(true)
  }

  return (
    <Modal
      onClose={() => { props.onClose(false) }}
      onConfirm={onComplete}
      open={true}
      confirmationContent={content}
      title='Reminder Details'
      confirmButtonText='Mark Complete'
      cancelButtonText='Close'
      maxWidth='md'
    />
  )
}
